<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>

        <div class="col-lg-12">
            <div class="card card-danger card-outline">
                <div class="card-header">
                    Fetch Price List
                </div>
                <div class="card-body overflow-auto">
                    <div class="form-group">
                        <label>Serial No.</label>
                        <input class="form-control" type="text" v-model="sl" placeholder="Enter the serial no." @keyup.enter="look">
                    </div>
                    <div class="form-group">
                        <label>Item Code</label>
                        <input class="form-control" type="text" v-model="item_code" placeholder="Enter the item code" @keyup.enter="look">
                    </div>
                </div>
                <div class="card-footer">
                    <div class="form-group">
                        <button class="btn btn-danger" style="width:100% !important;" @click="look">Lookup</button>
                    </div>
                </div>
            </div>
        </div>


        <div class="col-lg-12" v-for="i in results">
            <div class="card">
                <div class="card-body overflow-auto">
                    <div class="row">
                        <div class="col-md-9">
                            <div class="form-group">
                                <label>ItemCode:</label>
                                <b>{{i.ItemCode}}</b>
                            </div>
                            <div class="form-group">
                                <label>Item Name:</label>
                                {{i.ItemName}}
                            </div>
                            <div class="form-group">
                                <label>Serial:</label>
                                {{i.SerialNumber}}
                            </div>
                            <div class="form-group">
                                <label>Price List ID:</label>
                                <b>{{i.PriceListID}}</b>
                            </div>
                        </div>
                        <div class="col-md-3" float="right">
                            <h5>{{i.Company}}</h5>
                            <h3>{{i.Price}}</h3>
                            <h4>{{i.PriceListName}}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>


<!-- row end -->
    </section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        data(){
        	return {
        		sl: '',
        		item_code: '',
        		results: []
        	}
        },

        methods: {
        	look(){
        		axios.post("/api/getPriceList", {item_code: this.item_code, sl: this.sl})
        		.then(response => {
        			this.results = response.data;
        		})
        	}
        }
    }
</script>
